<div
  class="offcanvas offcanvas-start menubar d-block d-lg-none"
  tabindex="-1"
  id="menubar"
  aria-labelledby="offcanvasExampleLabel"
  #menubar
>
  <div class="offcanvas-header">
    <img src="assets/images/icons/brijwork_logo_main.svg" alt="logo" />
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <div class="user-info d-flex align-items-center border rounded-3 p-2 mb-2">
      <div class="user-avatar me-2 flex-shrink-0">
        <img
          [src]="
            userDetails.profileImgUrl ? userDetails.profileImgUrl : 'assets/images/company-management/ic_userSample.svg'
          "
          style="height: 50px; width: 50px; border-radius: 20%"
          alt="User"
        />
      </div>
      <div class="flex-grow-1">
        <h6 class="username mb-1">
          {{ userDetails.fullName }}
        </h6>

        <div class="d-flex flex-wrap align-items-center gap-1 mb-1">
          <span class="meta">{{ currentUserRoles.length ? currentUserRoles[0]?.name : '' }}</span>
          <div *ngIf="currentUserRoles.length > 1" class="c-pt view-more ms-1 position-relative role-hover-group">
            <span class="secondary mb-0" id="id_userRole">+{{ currentUserRoles.length - 1 }}</span>
            <ul class="show-list">
              <li *ngFor="let rl of currentUserRoles.slice(1)">• {{ rl.name }}</li>
            </ul>
          </div>
        </div>

        <div class="d-flex align-items-center gap-2">
          <span class="meta">Warehouse:</span>
          <span class="user-meta" (click)="openWarehouseSelectorModal()" style="cursor: pointer">
            {{ defaultWarehouseName || '-' }}
          </span>
        </div>
      </div>
    </div>
    <div class="menu-itmes mt-3">
      <ul style="list-style-type: none" *ngFor="let menu of menuItems">
        <li
          class="menu-item"
          data-bs-dismiss="offcanvas"
          [ngClass]="{
            'active-style': menu.active,
            'inactive-style': !menu.active,
            'text-danger': menu.title === 'Logout'
          }"
        >
          <a
            *ngIf="menu.title !== 'Product List' && menu.title !== 'Logout'; else specialLinks"
            [routerLink]="menu.route"
            [queryParams]="menu.queryParams"
            class="d-flex align-items-center"
            (click)="onMenuClick(menu.title)"
          >
            <img
              class="menu-icon"
              [src]="menu.active ? menu.activeIcon : menu.inactiveIcon"
              alt="{{ menu.title }} Icon"
            />
            <span>{{ menu.title }}</span>
          </a>
          <ng-template #specialLinks>
            <a
              href="javascript:void(0)"
              class="d-flex align-items-center"
              [ngClass]="{ 'text-danger': menu.title === 'Logout' }"
              (click)="menu.title === 'Logout' ? logout() : productListClick()"
            >
              <ng-container *ngIf="menu.title === 'Logout'; else otherSpecialIcon">
                <div class="menu-icon-wrapper d-flex justify-content-center align-items-center">
                  <i class="fas fa-sign-out-alt"></i>
                </div>
              </ng-container>
              <ng-template #otherSpecialIcon>
                <img
                  class="menu-icon"
                  [src]="menu.active ? menu.activeIcon : menu.inactiveIcon"
                  alt="{{ menu.title }} Icon"
                />
              </ng-template>
              <span>{{ menu.title }}</span>
            </a>
          </ng-template>
        </li>
      </ul>
    </div>
  </div>
</div>
<!-- Switch Warehouse Modal -->
<div
  class="modal fade"
  id="SwitchWarehouseModal"
  #switchWarehouseModal
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
  data-bs-backdrop="static"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="custom-modal-header py-0 modal-header">
        <h5 class="mb-0 border-0">Switch Warehouse</h5>
      </div>
      <div class="custom-modal-body modal-body">
        <div class="modal-body-wraapper">
          <div class="enter mb-3">
            <label for="name" class="form-label" id="lbl-OutletS">Warehouses</label>
            <select class="form-select border" aria-label="Default select example" [(ngModel)]="selectedWarehouseId">
              <option [ngValue]="0" hidden>Select warehouse</option>
              <option *ngFor="let item of warehouses" [ngValue]="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="radio-btn">
          <input
            class="form-check-input"
            type="checkbox"
            id="preference"
            [checked]="isDefault"
            (click)="toggleDefaultPreferrence()"
          />
          <label for="preference">Save my preference</label>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer pt-0">
        <button
          class="btn modal-btn text-nowrap"
          data-bs-dismiss="modal"
          aria-label="Close"
          [hidden]="selectedWarehouseId == 0"
          (click)="SaveWarehouse()"
          id="btn-Continue"
        >
          Continue
        </button>
        <button
          class="btn modal-btn text-nowrap"
          id="btn-continuepos"
          [hidden]="selectedWarehouseId > 0"
          style="background-color: #d4d4d4; color: white; border-color: #d4d4d4"
          disabled
        >
          Continue
        </button>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
